<div class=" p-5">
  <h2>Profil</h2>
  <div class="d-flex justify-content-between space-left">
    <div class="col-5">
      <table class="full-width" cellspacing="0">
        <tr>
          <td>
            <mat-form-field class="full-width">
              <input matInput disabled value="{{userfirstname}}" />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="full-width">
              <input matInput disabled value="{{userlastname}}" />
            </mat-form-field>
          </td>
        </tr>
      </table>
      <mat-form-field class="full-width">
        <input matInput disabled value="{{usermail}}" >
      </mat-form-field>
      <div class="d-flex align-items-center justify-content-between col-6">
        <div class="account-icon"><mat-icon aria-hidden="false" aria-label="search icon" fontIcon="account_circle" class="account"></mat-icon> </div>
        <div class="sign"><button mat-raised-button class="mb-3 save-btn col-white">Hochladen<mat-icon>cloud_upload</mat-icon></button></div>
        <div>Entfernen</div>
      </div>
      <mat-form-field class="full-width">
        <input matInput disabled value="Position bei Bosenet">
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Telefonnummer</mat-label>
        <input matInput >
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Signatur hochladen</mat-label>
        <input matInput>
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Passwort ändern</mat-label>
        <input matInput>
      </mat-form-field>
    </div>
    <div class="col-5 d-flex justify-content-end align-items-end">
      <div class="mar-right"><button mat-raised-button class="mb-3 save-btn col-white">Speichern</button></div>
      <div><button mat-raised-button class="mb-3 primary">Abbrechen</button></div>
    </div>
  </div>
</div>
